'use strict';

var vkBridge = require('@vkontakte/vk-bridge');
var vk_getAppId_index = require('../getAppId/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var vkBridge__default = /*#__PURE__*/_interopDefaultLegacy(vkBridge);

/**
 * Получаем токен пользователя ВК
 * @param {array | string} scope - Массив прав
 * @return {Promise}
 */
const bridgeGetAccessToken = (scope = []) => vkBridge__default['default'].send(
    'VKWebAppGetAuthToken',
    { app_id: vk_getAppId_index(), scope: Array.isArray(scope) ? scope.join(',') : scope },
);

module.exports = bridgeGetAccessToken;
